export const FETCH_EVENT_DATA_REQUEST = "FETCH_EVENT_DATA_REQUEST";

/* fetchAllEventData */
export const FETCH_ALL_EVENT_DATA_SUCCESS = "FETCH_ALL_EVENT_DATA_SUCCESS";

/* fetchAllEvents */
export const FETCH_ALL_EVENTS_SUCCESS = "FETCH_ALL_EVENTS_SUCCESS";
export const FETCH_ALL_EVENTS_FAILURE = "FETCH_ALL_EVENTS_FAILURE";

/* fetchAllEventCategories */
export const FETCH_EVENT_CATEGORIES_SUCCESS = "FETCH_EVENT_CATEGORIES_SUCCESS";
export const FETCH_EVENT_CATEGORIES_FAILURE = "FETCH_EVENT_CATEGORIES_FAILURE";